module.exports = __webpack_public_path__ + "fonts/06ae5aaa1fcf489b41aa77e27a735e0f.woff2";